<mf-page title="Movimientos bancarios">
  <mf-row>
    <mf-bank-movement-grid />
  </mf-row>
</mf-page>
